const ICON_PATHS = {
  bookmark: <path d="M6.75 4.75A1.75 1.75 0 0 1 8.5 3h7A1.75 1.75 0 0 1 17.25 4.75V21L12 17.5 6.75 21V4.75Z" />,
  check: <path d="m5 12.5 4.25 4.25L19 7" />,
  clone: <><rect x="5" y="7" width="11" height="11" rx="2" /><path d="M9 7V5a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2h-3M17 7v6M14 10h6" /></>,
  copy: <><rect x="8" y="8" width="11" height="11" rx="2" /><path d="M16 8V6a2 2 0 0 0-2-2H6a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2h2" /></>,
  close: <><path d="M6 6l12 12" /><path d="M18 6 6 18" /></>,
  edit: <><path d="M12 20h9" /><path d="M16.5 3.5a2.12 2.12 0 0 1 3 3L8 18l-4 1 1-4Z" /></>,
  plus: <><path d="M12 5v14" /><path d="M5 12h14" /></>,
  power: <><path d="M12 3v9" /><path d="M7.05 5.72a8 8 0 1 0 9.9 0" /></>,
  reset: <><path d="M3 12a9 9 0 1 0 3-6.7" /><path d="M3 4v6h6" /></>,
  trash: <><path d="M4 7h16" /><path d="M9 7V4h6v3M7 7l1 13h8l1-13M10 11v5M14 11v5" /></>,
};

export default function ActionIconButton({
  icon,
  label,
  title,
  active = false,
  tone = "default",
  className = "",
  ...buttonProps
}) {
  const classes = [
    "admin-action-icon-button",
    active ? "admin-action-icon-button--active" : "",
    tone !== "default" ? `admin-action-icon-button--${tone}` : "",
    className,
  ].filter(Boolean).join(" ");

  return (
    <button
      {...buttonProps}
      type={buttonProps.type || "button"}
      className={classes}
      aria-label={label}
      title={title === false ? undefined : title || label}
    >
      <svg aria-hidden="true" viewBox="0 0 24 24" focusable="false">
        {ICON_PATHS[icon] || ICON_PATHS.edit}
      </svg>
    </button>
  );
}
